import { EVENTS } from "../constants/events.constants";
import { allowedLangs, defaultLang } from "../constants/locales.constants";
export class Locale {
    #lang;
    locale;
    ref;
    // Value для того, чтобы объект отслеживался через watch, т.к. lang не отображается
    value = false;
    constructor(lang = defaultLang) {
        this.#lang = lang;
        this.locale = lang;
    }
    get lang() {
        return this.#lang;
    }
    set lang(value) {
        if (!allowedLangs.includes(value))
            return;
        if (this.beforeLangChange) {
            this.beforeLangChange(value).then(() => this.#setLang(value));
        }
        else {
            this.#setLang(value);
        }
        window.dispatchEvent(new CustomEvent(EVENTS.setLocale, {
            detail: value,
        }));
    }
    #setLang(value) {
        this.#lang = value;
        this.locale = value;
        this.value = Boolean(!this.value);
        if (this.onLangChange) {
            this.onLangChange(this.#lang);
        }
        if (this.ref) {
            this.ref.value = JSON.parse(JSON.stringify(value));
        }
    }
    setRef(ref) {
        ref.value = this.locale;
        this.ref = ref;
    }
    // Методы (коллбэки) без реализации:
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars, @typescript-eslint/no-empty-function
    onLangChange(lang) { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars, @typescript-eslint/no-empty-function
    async beforeLangChange(lang) { }
}
